import type { Media } from "@/types/media";

export const movies: Media[] = [
  {
    id: "m1",
    title: "星际穿越",
    type: "movie",
    year: 2014,
    region: "美国",
    genres: ["科幻", "冒险", "剧情"],
    rating: 9.4,
    heat: 9860,
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20film%20poster%20of%20an%20astronaut%20floating%20before%20a%20giant%20ringed%20planet%2C%20deep%20blue%20and%20amber%20lighting%2C%20cosmic%20dust%2C%20dramatic%20contrast%2C%20moody%20atmosphere&width=400&height=600&seq=ph-movie-01&orientation=portrait",
    synopsis:
      "近未来地球环境恶化，一支探险队穿越虫洞寻找人类新家园。他们必须在亲情与使命之间做出抉择，跨越时间与空间的阻隔，为人类的未来搏上一切。",
    director: "克里斯托弗·诺兰",
    cast: ["马修·麦康纳", "安妮·海瑟薇", "杰西卡·查斯坦", "迈克尔·凯恩"],
    duration: "169分钟",
  },
  {
    id: "m2",
    title: "无间道",
    type: "movie",
    year: 2002,
    region: "香港",
    genres: ["犯罪", "悬疑", "剧情"],
    rating: 9.3,
    heat: 8420,
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20crime%20thriller%20film%20poster%2C%20two%20silhouettes%20facing%20opposite%20directions%20on%20a%20rainy%20city%20rooftop%2C%20cold%20blue%20and%20neon%20reflections%2C%20noir%20tension%2C%20dark%20dramatic%20lighting&width=400&height=600&seq=ph-movie-02&orientation=portrait",
    synopsis:
      "警方卧底与黑帮内鬼身份互换，长期潜伏中，两人都在寻找真正的自己。当真相逐渐浮出水面，命运将他们推向天台上的终极对决。",
    director: "刘伟强 / 麦兆辉",
    cast: ["梁朝伟", "刘德华", "黄秋生", "曾志伟"],
    duration: "101分钟",
  },
  {
    id: "m3",
    title: "霸王别姬",
    type: "movie",
    year: 1993,
    region: "大陆",
    genres: ["剧情", "爱情", "历史"],
    rating: 9.6,
    heat: 7980,
    poster:
      "https://readdy.ai/api/search-image?query=period%20drama%20film%20poster%2C%20traditional%20Chinese%20opera%20performer%20in%20ornate%20red%20and%20gold%20costume%20on%20a%20dim%20stage%2C%20theatrical%20spotlight%2C%20rich%20crimson%20and%20deep%20shadow%2C%20elegant%20composition&width=400&height=600&seq=ph-movie-03&orientation=portrait",
    synopsis:
      "两位京剧伶人半个世纪的悲欢离合，横跨时代变迁。台上台下，戏里戏外，一段关于执着、背叛与深情的传奇故事。",
    director: "陈凯歌",
    cast: ["张国荣", "张丰毅", "巩俐", "葛优"],
    duration: "171分钟",
  },
  {
    id: "m4",
    title: "盗梦空间",
    type: "movie",
    year: 2010,
    region: "美国",
    genres: ["科幻", "悬疑", "动作"],
    rating: 9.4,
    heat: 9210,
    poster:
      "https://readdy.ai/api/search-image?query=surreal%20sci-fi%20film%20poster%2C%20a%20city%20folding%20onto%20itself%20like%20a%20maze%2C%20dreamlike%20distortion%2C%20cool%20steel%20blue%20tone%20with%20warm%20highlights%2C%20cinematic%20depth%2C%20mysterious%20atmosphere&width=400&height=600&seq=ph-movie-04&orientation=portrait",
    synopsis:
      "一名被盗梦技术困扰的窃贼，接下一项史无前例的任务：在目标的潜意识中植入一个念头。层层梦境之间，现实与虚幻的边界彻底模糊。",
    director: "克里斯托弗·诺兰",
    cast: ["莱昂纳多·迪卡普里奥", "约瑟夫·高登-莱维特", "艾伦·佩吉"],
    duration: "148分钟",
  },
  {
    id: "m5",
    title: "我不是药神",
    type: "movie",
    year: 2018,
    region: "大陆",
    genres: ["剧情", "喜剧"],
    rating: 9.0,
    heat: 8650,
    poster:
      "https://readdy.ai/api/search-image?query=social%20drama%20film%20poster%2C%20a%20lone%20man%20walking%20through%20a%20crowded%20night%20street%20market%2C%20warm%20yellow%20streetlight%20against%20cool%20blue%20shadows%2C%20gritty%20realistic%20mood%2C%20cinematic&width=400&height=600&seq=ph-movie-05&orientation=portrait",
    synopsis:
      "一个卖神油的小商贩意外成为印度仿制药代理商，在一场关于生存与良知的博弈中，他完成了从逐利到救赎的转变。",
    director: "文牧野",
    cast: ["徐峥", "王传君", "周一围", "谭卓"],
    duration: "117分钟",
  },
  {
    id: "m6",
    title: "肖申克的救赎",
    type: "movie",
    year: 1994,
    region: "美国",
    genres: ["剧情", "犯罪"],
    rating: 9.7,
    heat: 9520,
    poster:
      "https://readdy.ai/api/search-image?query=classic%20prison%20drama%20film%20poster%2C%20a%20man%20standing%20in%20falling%20rain%20with%20arms%20raised%2C%20grey%20stone%20walls%2C%20moody%20blue-grey%20palette%20with%20a%20hint%20of%20golden%20light%2C%20hopeful%20cinematic%20tone&width=400&height=600&seq=ph-movie-06&orientation=portrait",
    synopsis:
      "一位被冤入狱的银行家，在漫长的铁窗岁月中始终不曾放弃希望。他用智慧与坚韧，书写了一段关于自由与救赎的不朽传奇。",
    director: "弗兰克·德拉邦特",
    cast: ["蒂姆·罗宾斯", "摩根·弗里曼", "鲍勃·冈顿"],
    duration: "142分钟",
  },
  {
    id: "m7",
    title: "唐人街探案",
    type: "movie",
    year: 2015,
    region: "大陆",
    genres: ["喜剧", "悬疑", "动作"],
    rating: 7.7,
    heat: 7320,
    poster:
      "https://readdy.ai/api/search-image?query=playful%20comedy%20mystery%20film%20poster%2C%20bustling%20colorful%20Chinatown%20night%20alley%20with%20lanterns%2C%20warm%20red%20and%20teal%20neon%20glow%2C%20energetic%20vibrant%20scene%2C%20cinematic&width=400&height=600&seq=ph-movie-07&orientation=portrait",
    synopsis:
      "天赋异禀的少年与落魄大叔组成奇葩侦探搭档，在异国唐人街卷入一桩离奇案件。笑料百出的背后，真相却远比想象中复杂。",
    director: "陈思诚",
    cast: ["王宝强", "刘昊然", "佟丽娅", "陈赫"],
    duration: "135分钟",
  },
  {
    id: "m8",
    title: "战狼2",
    type: "movie",
    year: 2017,
    region: "大陆",
    genres: ["动作", "战争"],
    rating: 7.1,
    heat: 6980,
    poster:
      "https://readdy.ai/api/search-image?query=action%20war%20film%20poster%2C%20silhouette%20of%20a%20lone%20soldier%20walking%20through%20smoke%20and%20fire%2C%20burning%20orange%20embers%20against%20dark%20charcoal%20background%2C%20heroic%20epic%20cinematic%20contrast&width=400&height=600&seq=ph-movie-08&orientation=portrait",
    synopsis:
      "一位退役特种兵卷入非洲某国的战乱，为营救同胞孤身深入险境，用血肉之躯诠释了何为责任与担当。",
    director: "吴京",
    cast: ["吴京", "弗兰克·格里罗", "卢靖姗", "吴刚"],
    duration: "123分钟",
  },
  {
    id: "m9",
    title: "千与千寻",
    type: "movie",
    year: 2001,
    region: "日本",
    genres: ["动画", "奇幻", "冒险"],
    rating: 9.4,
    heat: 8760,
    poster:
      "https://readdy.ai/api/search-image?query=whimsical%20animated%20fantasy%20poster%2C%20a%20glowing%20spirit%20world%20lantern%20street%20with%20soft%20teal%20and%20warm%20gold%20lights%2C%20dreamlike%20magical%20atmosphere%2C%20delicate%20illustration%20style&width=400&height=600&seq=ph-movie-09&orientation=portrait",
    synopsis:
      "少女千寻误入神灵的世界，父母变成了猪。为了救回家人，她在汤屋中辛勤工作，逐渐成长，也找回了遗失的勇气与纯真。",
    director: "宫崎骏",
    cast: ["柊瑠美", "入野自由", "夏木真理", "菅原文太"],
    duration: "125分钟",
  },
  {
    id: "m10",
    title: "蝙蝠侠：黑暗骑士",
    type: "movie",
    year: 2008,
    region: "美国",
    genres: ["动作", "犯罪", "悬疑"],
    rating: 9.2,
    heat: 8390,
    poster:
      "https://readdy.ai/api/search-image?query=dark%20superhero%20crime%20film%20poster%2C%20a%20mysterious%20masked%20figure%20against%20a%20stormy%20night%20cityscape%2C%20cold%20blue%20and%20violet%20shadow%2C%20brooding%20noir%20atmosphere%2C%20high%20contrast&width=400&height=600&seq=ph-movie-10&orientation=portrait",
    synopsis:
      "当一位癫狂的罪犯将整座城市拖入恐慌，正义与秩序面临前所未有的考验。英雄必须在原则与混乱之间做出艰难抉择。",
    director: "克里斯托弗·诺兰",
    cast: ["克里斯蒂安·贝尔", "希斯·莱杰", "艾伦·艾克哈特"],
    duration: "152分钟",
  },
  {
    id: "m11",
    title: "流浪地球",
    type: "movie",
    year: 2019,
    region: "大陆",
    genres: ["科幻", "灾难", "冒险"],
    rating: 7.9,
    heat: 7640,
    poster:
      "https://readdy.ai/api/search-image?query=epic%20sci-fi%20disaster%20film%20poster%2C%20planet%20earth%20with%20giant%20engine%20flames%20against%20icy%20space%2C%20freezing%20blue%20and%20burning%20orange%20contrast%2C%20vast%20dramatic%20scale%2C%20cinematic&width=400&height=600&seq=ph-movie-11&orientation=portrait",
    synopsis:
      "太阳即将膨胀吞噬地球，人类倾尽全力建造行星发动机推动地球流浪宇宙。当灾难降临，一群普通人挺身而出，为文明的存续拼尽全力。",
    director: "郭帆",
    cast: ["屈楚萧", "吴京", "李光洁", "吴孟达"],
    duration: "125分钟",
  },
  {
    id: "m12",
    title: "让子弹飞",
    type: "movie",
    year: 2010,
    region: "大陆",
    genres: ["剧情", "喜剧", "动作"],
    rating: 9.1,
    heat: 8110,
    poster:
      "https://readdy.ai/api/search-image?query=bold%20period%20action%20film%20poster%2C%20a%20stylized%20western%20town%20with%20train%20and%20mountains%2C%20warm%20amber%20sunlight%20and%20deep%20red%20accents%2C%20witty%20grand%20scale%20cinematic%20scene&width=400&height=600&seq=ph-movie-12&orientation=portrait",
    synopsis:
      "民国年间，一位自称县长的骗子与一方霸主展开明争暗斗。枪声与笑声交织，一场关于权谋、义气与民心的江湖大戏拉开帷幕。",
    director: "姜文",
    cast: ["姜文", "葛优", "周润发", "刘嘉玲"],
    duration: "132分钟",
  },
];